import * as React from 'react';
import { PlayStateEnum } from '../interfaces/state';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';

interface PlayPauseProps {
    isLoading: boolean;
    isPlaying: PlayStateEnum;
    isKeyboardShortcutVisible: boolean;
    onPlayClick: () => void;
    onPauseClick: () => void;
}

export class PlayPause extends React.Component<PlayPauseProps, {}> {
    constructor(props: PlayPauseProps) {
        super(props);
    }

    render() {
        if (this.props.isLoading) {
            return (
                <button id="Playback" className="btn btn-primary" disabled>
                    <i className="fas fa-circle-notch fa-spin fa-fw" aria-hidden="true"></i>&nbsp;
                    Loading
                </button>
            );
        } else if (this.props.isPlaying == PlayStateEnum.Playing) {
            return (
                <button id="Playback" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); this.props.onPauseClick() }}>
                    <i className="fas fa-pause" aria-hidden="true"></i>
                    <KeyboardShortcutTooltip show={this.props.isKeyboardShortcutVisible} keyName="SPACE" />
                </button>
            );
        } else if (this.props.isPlaying == PlayStateEnum.NotStarted || this.props.isPlaying == PlayStateEnum.Paused) {
            return (
                <button id="Playback" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); this.props.onPlayClick() }}>
                    <i className="fas fa-play" aria-hidden="true"></i>
                    <KeyboardShortcutTooltip show={this.props.isKeyboardShortcutVisible} keyName="SPACE" />
                </button>
            );
        } else {
            return null;
        }
    }
}
